import { BorderBox } from "@/components/atoms/BorderBox";
import { FieldOptionRendererSchema, FieldOptionsRendererProps, QuestionInstanceFieldOptionsWouldBeLostProps } from ".";
import { PickGroupRankOptions } from "@/types/crm/tables/question";
import { ListTodo } from "lucide-react";

export function QuestionInstanceFieldOptionsWouldBeLost({ context }: QuestionInstanceFieldOptionsWouldBeLostProps) {
    return (
        <BorderBox size={"sm"} className="flex flex-col items-start" >
            <h4 className="flex items-center gap-1 font-semibold"><ListTodo size="16"/>Field options from instance will be lost</h4>

            <BorderBox size={"sm"} className="flex flex-col items-start bg-white" >
                <div className="grid w-full grid-cols-3 gap-1">
                    <div className="flex flex-col w-full gap-1">
                        <h4 className="text-xs text-muted-foreground">Instance options:</h4>
                        <FieldOptionsRenderer options={context.instanceFieldOptions} />
                    </div>
                    <div className="flex flex-col w-full gap-1">
                        <h4 className="text-xs text-muted-foreground">Options that would be lost:</h4>
                        <FieldOptionsRenderer options={context.optionsThatWouldBeLost} />
                    </div>
                    <div className="flex flex-col w-full gap-1">
                        <h4 className="text-xs text-muted-foreground">Template (new) options:</h4>
                        {
                            context.templateFieldOptions
                                ? <FieldOptionsRenderer options={context.templateFieldOptions} />
                                : <span className="text-sm text-muted-foreground">No options in template</span>
                        }
                    </div>
                </div>
            </BorderBox>


        </BorderBox>
    )
}

function FieldOptionsRenderer({ options }: FieldOptionsRendererProps) {
    if (Array.isArray(options)) {
        return options.map((option, i) => typeof option === 'string'
            ? <FieldOptionItemRenderer option={option} key={option} />
            : <FieldOptionItemRenderer option={option} key={i} />
        )
    }
    if (isPickGroupRankOptions(options)) {
        return (
            <div className="grid grid-cols-2 gap-2">
                <div className="">
                    <h4>Groups:</h4>
                    <div className="flex flex-col gap-1">
                        {options.groups.map((group, i) => typeof group === 'string'
                            ? <FieldOptionItemRenderer option={group} key={group} />
                            : <FieldOptionItemRenderer option={group} key={i} />
                        )}
                    </div>
                </div>
                <div className="">
                    <h4>Options:</h4>
                    <div className="flex flex-col gap-1">
                        {options.options.map((option, i) => typeof option === 'string'
                            ? <FieldOptionItemRenderer option={option} key={option} />
                            : <FieldOptionItemRenderer option={option} key={i} />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

const isPickGroupRankOptions = (option: any): option is PickGroupRankOptions => 'group' in option

function FieldOptionItemRenderer({ option }: FieldOptionRendererSchema) {
    return (
        <BorderBox size="xs" className="w-full px-2 py-1">
            {typeof option === 'string'
                ? option
                : <>
                    <div className="flex ">
                        <div className="flex flex-col gap-1">
                            <span className="font-semibold">Label:</span>
                            <span className="font-semibold">Value:</span>
                        </div>
                        <div className="flex flex-col gap-1">
                            <span>{option.label}</span>
                            <span>{option.value}</span>
                        </div>
                    </div>
                </>
            }
        </BorderBox>
    )
}